const NO_OP = (message, ...optionalParams) => { };

/** Logger which outputs to the browser console */
const consoleLogger = (options) => {
  const { level } = options;

  const error = console.error.bind(console);
  let warn = console.warn.bind(console);
  let log = console.log.bind(console);

  if (level === "error") {
    warn = NO_OP;
    log = NO_OP;
  } else if (level === "warn") {
    log = NO_OP;
  }

  return { log, warn, error };
};

const LOG_LEVEL = process.env.NODE_ENV === "production" ? "warn" : "log";

// level = "log" | "warn" | "error";
export const logger = consoleLogger({ level: LOG_LEVEL });
